import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedMovies from "./components/FeaturedMovies";
import MovieRanking from "./components/MovieRanking";
import ArticleSection from "./components/ArticleSection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background-50">
      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />
        <FeaturedMovies />
        <MovieRanking />
        <ArticleSection />
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "555电影网 - 首页",
          url: "https://555movie.com/",
          description:
            "555电影网提供555电影免费高清在线观看服务，海量全集电影不缓冲秒播放",
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "首页",
                item: "https://555movie.com/",
              },
            ],
          },
        })}
      </script>
    </div>
  );
}